import(/* webpackMode: "eager" */ "/app/app/articles/how-to-submit-urls-to-bing-with-indexnow/page.tsx");
